import update from 'immutability-helper';
import * as types from './types';

const initialState = {
  isFetching: true,
  hasError: false,
  selectedAiAlertDiagnostics: {},
  selectedAiAlert: {},
};

const switchMap = {};

switchMap[types.INIT] = (state) =>
  update(state, {
    $set: initialState,
  });

switchMap[types.FETCHING] = (state, action) =>
  update(state, {
    isFetching: { $set: action.flag },
  });

switchMap[types.SET_ERROR] = (state, action) =>
  update(state, {
    hasError: { $set: action.flag },
  });

switchMap[types.SET_DIAGNOSTICS_DATA] = (state, action) =>
  update(state, {
    selectedAiAlertDiagnostics: { $set: action.payload },
  });

export default (state = initialState, action) =>
  switchMap[action.type] ? switchMap[action.type](state, action) : state;
